import { useAuth } from 'auth/AuthContext'
import { Button, Input } from 'components'
import { ENV } from 'constants/envs'
import * as links from 'constants/links'
import { LOADING_BUTTON, LOGIN_BUTTON, LOGIN_TITLE } from 'data/information'
import { ERROR_PASSWORD, ERROR_USERNAME, PASSWORD, USERNAME } from 'data/input'
import { IUser } from 'interfaces'
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { rules } from './rules'
import { Container, FormContainer, Title } from './styled'

const Login = () => {
  const history = useHistory();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false)

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IUser>({
    mode: 'onChange',
  })

  const onSubmit = async (data: IUser) => {
    setLoading(true);

    try {
      await login(data)
      history.push(links.dashboard)
    } catch (error) {
      console.error('Error de inicio de sesión:', error);
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    ENV === 'development' &&
      reset({
        username: 'maythe2023',
        password: 'Mga987804573',
      })
  }, [])

  return (
    <Container>
      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <Title>{LOGIN_TITLE}</Title>
        <Controller
          control={control}
          name='username'
          rules={rules.username}
          render={({ field: { value, onChange, onBlur } }) => (
            <Input
              type='text'
              placeholder={USERNAME}
              label={USERNAME}
              value={value || ''}
              onChange={onChange}
              onBlur={onBlur}
              error={errors?.username && ERROR_USERNAME}
            />
          )}
        />
        <Controller
          control={control}
          name='password'
          rules={rules.password}
          render={({ field: { value, onChange, onBlur } }) => (
            <Input
              type='password'
              placeholder={PASSWORD}
              label={PASSWORD}
              value={value || ''}
              onChange={onChange}
              onBlur={onBlur}
              error={errors?.password && ERROR_PASSWORD}
            />
          )}
        />
        <Button
          disabled={loading}
          type='submit'
          value={loading ? LOADING_BUTTON : LOGIN_BUTTON}
        />
      </FormContainer>
    </Container>
  )
}

export default Login